var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SplitViewTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"backButtonRoute":'/settings/company',"dataModel":_vm.formModel,"formConfig":_vm.setFormConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }